var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTelegram = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 15.996,
  height: 16,
  fill: "url(#svg-3738250508__a)",
  rx: 7.998
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M3.618 7.917A532 532 0 0 1 8.28 5.904c2.219-.926 2.685-1.086 2.985-1.093.067 0 .213.014.313.094.08.066.1.153.113.22.014.066.027.206.014.313-.12 1.266-.64 4.338-.906 5.75-.114.6-.334.8-.547.82-.466.04-.82-.306-1.266-.6-.706-.46-1.099-.746-1.785-1.199-.793-.52-.28-.806.173-1.273.12-.12 2.165-1.986 2.205-2.152.007-.02.007-.1-.04-.14-.046-.04-.113-.027-.166-.013-.073.013-1.193.76-3.371 2.232q-.479.33-.866.32c-.287-.007-.833-.16-1.246-.293-.5-.16-.9-.247-.866-.527q.032-.218.593-.446Z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-3738250508__a",
  x1: 7.991,
  x2: 7.991,
  y1: 0,
  y2: 15.873,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2AABEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#229ED9"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };